"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTheme = void 0;
var react_1 = require("react");
var ThemeContext_1 = require("../theme/ThemeContext");
exports.useTheme = function () {
    return react_1.useContext(ThemeContext_1.ThemeContext);
};
//# sourceMappingURL=useTheme.js.map